
const API_KEY = 'ff043062c6b26efa864683f855841df9';

export default API_KEY;